import React from 'react'
import styled from 'styled-components'
import UserMenu from './UserMenu'
import Menu from 'react-burger-menu/lib/menus/slide'

const ReactBurgerAdapter = ({className, ...props}) => {
  const burgerButton = `${className}__burgerButton`
  const burgerBars = `${className}__burgerBars`
  const crossButton = `${className}__crossButton`
  const cross = `${className}__cross`
  const menu = `${className}__menu`
  const itemList = `${className}__itemList`
  const overlay = `${className}__overlay`
  const wrapper = `${className}__wrapper`
  return (
    <Menu
      burgerButtonClassName={burgerButton}
      burgerBarClassName={burgerBars}
      crossButtonClassName={crossButton}
      crossClassName={cross}
      menuClassName={menu}
      itemListClassName={itemList}
      overlayClassName={overlay}
      className={wrapper}
      {...props}
    />
  )
}

const StyledMenu = styled(ReactBurgerAdapter)`
  &__wrapper {
    top: 80px;

    height: calc(100vh - 80px) !important;
    box-sizing: border-box;
    background-color: pink;

    @media (max-width: 420px) {
      top: 80px;
      height: calc(100vh - 80px) !important;
    }
  }

  /* Position and sizing of burger button */
  &__burgerButton {
    position: relative;
    z-index: 1010;
  }

  /* Color/shape of burger icon bars */
  &__burgerBars {
    background: white;
  }

  /* Position and sizing of clickable cross button */
  &__crossButton {
    height: 24px;
    width: 24px;
    display: none;
  }

  /* Color/shape of close button cross */
  &__cross {
    background: #bdc3c7;
  }

  /* General sidebar styles */
  &__menu {
    background: #282d41;
    padding: 0;
    font-size: 1.15em;
  }

  /* Wrapper for item list */
  &__itemList {
    color: #b8b7ad;
    padding: 0 0 0.8em 0;
  }

  /* Styling of overlay */
  &__overlay {
    background: rgba(0, 0, 0, 0.3);
    top: 80px;
    width: 100vw;
  }
`

const BurgerMenu = ({children, user}) => {
  const isMobileOnly = window.matchMedia('(max-width:420px)').matches
  return (
    <StyledMenu
      right
      width={isMobileOnly ? '100%' : '320px'}
      customBurgerIcon={<UserMenu user={user} />}
    >
      {children}
    </StyledMenu>
  )
}

export default BurgerMenu
